import React, { useEffect } from "react";
import { Grid, Typography, Container, Divider } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ForwardIcon from "@material-ui/icons/Forward";
import AboutProcess from "./AboutProcess";
import about_illus from "../../assets/about_image.svg";

const About = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t("title")} | ${t("about")}`;
  }, [t]);
  return (
    <div id="about">
      <Container className='my-4'>
        <Grid container direction="row">
          <Grid container direction="column" xs={12} sm={6} md={6} spacing={3}>
            <Grid item>
              {/* <Typography className="tp txt-bold" variant="h2">{t("about")}</Typography> */}
			  <Typography className="tp" variant="h4">{t("who-we-are")}</Typography>
              <Typography component="p" className='txt-justify'>{t("about-text")}</Typography>
              <Typography component="p" className='txt-justify'>{t("about-text-two")}</Typography>
            </Grid>
            <Divider />
            {/* <Grid item>
              <Typography variant="h4">
                {t("affordable-housing-projects")}
              </Typography>
              <Typography component="p">{t("interest-rate")}.</Typography>
            </Grid> */}
          </Grid>
          <Grid  xs={12} sm={6} md={6}>
            <img src={about_illus} alt="house search" width={"100%"} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default About;
